import React, { useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { HotKeys } from '@web-mail/common/library/HotKeys/react-hotkeys';
import { VariableSizeList as VirtualList } from 'react-window';
import { AutoSizer } from 'react-virtualized/dist/commonjs/AutoSizer';
import { api } from 'api';
import styles from './index.module.scss';
import debounce from 'lodash/debounce';
import { getContactItemKey, getSelectedItemBySelectOrg, isOrg, transCustomerSearchData, transOrgSearch2OrgItem, } from '@web-common/components/util/contact';
import { SpinIcon } from '../../Icons/icons';
import { contactApi } from '@web-common/utils/contact_util';
import ListItem from '../listItem';
import useContactItemEffect from '@web-common/components/UI/SiriusContact/useContactItemEffect';
import { transContactSearch2ContactItem } from '@web-common/components/util/contact';
import { MemberList } from '@web-contact/component/MemberList/MemberList';
import { getIn18Text } from 'api';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
var ListHotKey;
(function (ListHotKey) {
    ListHotKey[ListHotKey["KEY_UP"] = 0] = "KEY_UP";
    ListHotKey[ListHotKey["KEY_DOWN"] = 1] = "KEY_DOWN";
    ListHotKey[ListHotKey["KEY_ENTER"] = 2] = "KEY_ENTER";
})(ListHotKey || (ListHotKey = {}));
const keyMap = {
    [ListHotKey.KEY_UP]: 'up',
    [ListHotKey.KEY_DOWN]: 'down',
    [ListHotKey.KEY_ENTER]: 'enter',
};
const sysApi = api.getSystemApi();
const textMap = {
    noCondition: 'WUFUHETIAOJIAN',
    noMore: 'DAODILA~',
};
const tranText = (text) => {
    return getIn18Text(textMap[text]);
};
const ContactList = React.forwardRef((props, ref) => {
    const { isIM = true, showAvatar = true, showCheckbox = true, showPosition = true, showAddTeamBtn, showAddPersonalBtn, multiple = true, type = 'all', useContactId, useOrgUnit, useEdm, isCustomerFirst = false, accountRootKey: _account, onSelect, defaultSelectList = [], disableCheckList: defaultDisableCheckList, noRelateEnterprise = false, excludeSelf, showAddOrgBtn, deduplicationByEmail = true, flattenPersonalEmails = false, } = props;
    const [showMemberList, setShowMemberList] = useState(false);
    const [selectedMailList, setSelectedMailList] = useState();
    const [selectedContact, setSelectedContact] = useState();
    const [selectedMap, setSelectedMap] = useState(new Map());
    const [disabledMap, setDisabledMap] = useState(new Map());
    const [searchList, setSearchList] = useState([]);
    const [searchListLoading, setSearchListLoading] = useState(false);
    const [searchValue, setSearchValue] = useState();
    const hotKeyInnerRef = useRef(null);
    const listRef = useRef(null);
    const listScrollRef = useRef(null);
    const inputValueRef = useRef('');
    useContactItemEffect(defaultSelectList, () => {
        const itemMap = new Map();
        defaultSelectList.forEach(item => {
            const key = isOrg(item) ? item.id : getContactItemKey(item, useContactId);
            itemMap.set(key, item);
        });
        setSelectedMap(itemMap);
    }, useContactId);
    useEffect(() => {
        if (defaultDisableCheckList === null || defaultDisableCheckList === void 0 ? void 0 : defaultDisableCheckList.length) {
            const itemMap = new Map();
            defaultDisableCheckList.forEach(item => {
                const key = isOrg(item) ? item.id : getContactItemKey(item, useContactId);
                itemMap.set(key, item);
            });
            setDisabledMap(itemMap);
        }
    }, [defaultDisableCheckList]);
    const handleSelectedItem = (params, checked = true) => {
        const data = params || selectedContact || searchList[0];
        if (!data) {
            return;
        }
        if (isOrg(data)) {
            handleOrgSelect(data, checked);
        }
        else {
            handleContactSelect(data);
        }
    };
    const handleOrgSelect = async (data, checked) => {
        if (useOrgUnit) {
            if (multiple) {
                selectedMap.set(data.id, data);
                setSelectedMap(selectedMap);
                onSelect && onSelect([...selectedMap.values()], [data]);
            }
            else {
                onSelect && onSelect([data], [data]);
            }
        }
        else {
            const { contactItem, selectContactItem } = await getSelectedItemBySelectOrg({
                checked,
                selectedList: [],
                idList: [data.id],
                selectedMap: selectedMap,
                useEdm: (data === null || data === void 0 ? void 0 : data.orgType) === 'customer' || (data === null || data === void 0 ? void 0 : data.orgType) === 'clue',
            });
            const orgTypeList = ['team', 'customer', 'personalOrg'];
            if (orgTypeList.includes(data === null || data === void 0 ? void 0 : data.orgType)) {
                const index = searchList.findIndex(item => item.id === data.id);
                if (index !== -1) {
                    setSearchList(_data => {
                        _data.splice(index, 1, Object.assign(Object.assign({}, data), { children: selectContactItem }));
                        return _data;
                    });
                }
            }
            if (multiple) {
                setSelectedMap(contactItem);
                onSelect && onSelect([...contactItem.values()], selectContactItem);
            }
            else {
                onSelect && onSelect(selectContactItem, selectContactItem);
            }
        }
    };
    const handleContactSelect = async (data) => {
        setSelectedContact(data);
        if (multiple) {
            const key = getContactItemKey(data, useContactId);
            const isDisabled = disabledMap.has(key);
            if (isDisabled) {
                return;
            }
            const isSelected = selectedMap.has(key);
            isSelected ? selectedMap.delete(key) : selectedMap.set(key, data);
            setSelectedMap(selectedMap);
            onSelect && onSelect([...selectedMap.values()], [data]);
        }
        else {
            onSelect && onSelect([data], [data]);
        }
    };
    const handleListMove = (stepNum) => {
        var _a;
        let step = stepNum;
        if ((searchList === null || searchList === void 0 ? void 0 : searchList.length) === 0) {
            return;
        }
        let currentIndex = 0;
        console.warn('selectedContact', selectedContact);
        if (selectedContact) {
            currentIndex = searchList.findIndex(item => {
                return selectedContact.id === item.id;
            });
        }
        else {
            step = 0;
        }
        const targetIndex = currentIndex + step;
        if (targetIndex < searchList.length && searchList[targetIndex]) {
            setSelectedContact(searchList[targetIndex]);
            (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToItem(targetIndex);
        }
    };
    const handleInputEnter = () => {
        handleSelectedItem();
    };
    const handleInputKeyDown = e => {
        if (e.keyCode === 38 || e.keyCode === 40) {
            let step;
            if (e.keyCode === 38) {
                step = -1;
            }
            else {
                step = 1;
            }
            handleListMove(step);
        }
    };
    const handleInputChange = (e) => {
        if (typeof e === 'string') {
            setSearchValue(e);
            return;
        }
        const { value } = e.target;
        setSearchValue(value);
    };
    const getRowHeight = useCallback(index => {
        const item = searchList[index];
        let size = 60;
        if (item) {
            if (!('orgType' in item)) {
                if (item.type === 'enterprise' && item.position) {
                    size = 72;
                }
            }
        }
        return size;
    }, [searchList]);
    useImperativeHandle(ref, () => ({
        handleInputEnter,
        handleInputKeyDown,
        handleInputChange,
    }));
    const doSearch = useCreateCallbackForEvent((query) => {
        setSearchListLoading(!0);
        const condition = {
            query,
            showDisable: false,
            isIM,
            useEdmData: useEdm,
            _account,
            noRelateEnterprise,
            flattenMuliptleEmails: flattenPersonalEmails,
        };
        type !== 'all' && (condition.contactType = type);
        if (showAddOrgBtn) {
            window.bridgeApi.master.forbiddenBridgeOnce();
            condition.enableUseMemory = false;
        }
        contactApi.doSearchAllContactNew(condition, result => {
            if (inputValueRef.current !== query) {
                return;
            }
            const { main, edm } = result;
            let myCustomerContacts = [];
            let myClueContacts = [];
            let myCustomerOrgs = [];
            let myClueOrgs = [];
            if (useEdm && edm) {
                const orderEdmData = transCustomerSearchData(edm);
                myCustomerContacts = orderEdmData['myCustomerContact'];
                myCustomerOrgs = orderEdmData['myCustomer'];
            }
            const personalContacts = [];
            const enterpriseContacts = [];
            const otherContacts = [];
            let teams = [];
            let personalOrgs = [];
            Object.keys(main).forEach(account => {
                const data = main[account] || {};
                const { contactList, teamList, personalOrgList } = data;
                if (contactList === null || contactList === void 0 ? void 0 : contactList.length) {
                    data.contactList.forEach(item => {
                        const { type } = item;
                        const transferedItem = transContactSearch2ContactItem(item);
                        if (type === 'enterprise') {
                            enterpriseContacts.push(transferedItem);
                        }
                        else if (type === 'personal') {
                            personalContacts.push(transferedItem);
                        }
                        else {
                            otherContacts.push(transferedItem);
                        }
                    });
                }
                if (showAddTeamBtn && (teamList === null || teamList === void 0 ? void 0 : teamList.length)) {
                    teams = teamList.map(item => transOrgSearch2OrgItem(item));
                }
                if (showAddPersonalBtn && (personalOrgList === null || personalOrgList === void 0 ? void 0 : personalOrgList.length)) {
                    personalOrgs = personalOrgList.map(transOrgSearch2OrgItem);
                }
            });
            console.log('searchList datas', { main, edm }, enterpriseContacts, myCustomerContacts, myClueContacts, personalContacts, otherContacts, teams, myCustomerOrgs, myClueOrgs);
            const allContactSet = new Set();
            let sortContacts = [];
            if (useEdm && isCustomerFirst) {
                sortContacts = [...myCustomerContacts, ...myClueContacts, ...enterpriseContacts, ...personalContacts, ...otherContacts];
            }
            else {
                sortContacts = [...enterpriseContacts, ...myCustomerContacts, ...myClueContacts, ...personalContacts, ...otherContacts];
            }
            const duplicateRemContacts = sortContacts.reduce((total, cur) => {
                const { email: emailAddr } = cur;
                const enablededuplicate = cur.type !== 'personal' || deduplicationByEmail;
                if (allContactSet.has(emailAddr) && enablededuplicate) {
                    return total;
                }
                allContactSet.add(emailAddr);
                total.push(cur);
                return total;
            }, []);
            allContactSet.clear();
            const searchedList = [...duplicateRemContacts, ...teams, ...myCustomerOrgs, ...myClueOrgs, ...personalOrgs];
            setSearchList(searchedList);
            setSelectedContact(searchedList[0]);
            setSearchListLoading(false);
        });
    });
    const debounceSearch = useCallback(debounce(value => {
        doSearch(value);
    }, 700, {
        leading: true,
    }), []);
    useEffect(() => {
        if (!searchValue) {
            setSearchListLoading(false);
            setSearchList([]);
        }
        else {
            inputValueRef.current = searchValue;
            debounceSearch(searchValue);
        }
    }, [searchValue]);
    const listHotKeyHandler = {
        [ListHotKey.KEY_UP]: (e) => {
            e && e.preventDefault();
            handleListMove(-1);
        },
        [ListHotKey.KEY_DOWN]: (e) => {
            e && e.preventDefault();
            handleListMove(1);
        },
        [ListHotKey.KEY_ENTER]: (e) => {
            e && e.preventDefault();
            handleSelectedItem();
        },
    };
    const renderNoData = () => React.createElement("div", { className: styles.noData }, tranText('noCondition'));
    const renderData = () => (React.createElement(AutoSizer, null, ({ width, height }) => (React.createElement(HotKeys, { keyMap: keyMap, handlers: listHotKeyHandler, allowChanges: true, innerRef: hotKeyInnerRef },
        React.createElement(VirtualList, { itemSize: getRowHeight, itemCount: searchList.length + (searchValue && searchList.length === 0 ? 0 : 1), height: height, width: width, ref: listRef, outerRef: listScrollRef, className: "sirius-scroll" }, ({ index, style }) => {
            var _a, _b, _c, _d;
            if (index === searchList.length) {
                return (React.createElement("div", { className: styles.noMore, style: Object.assign({}, style) }, tranText('noMore')));
            }
            const item = searchList[index];
            const hiddenItem = excludeSelf && item.id === ((_b = (_a = sysApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contact.id);
            if (hiddenItem) {
                return null;
            }
            const isLeaf = !isOrg(item);
            const selected = (selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.id) === item.id;
            let checked = false;
            let disableCheck;
            if (isLeaf) {
                const contactKey = getContactItemKey(item, useContactId, item.type === 'personal' && !deduplicationByEmail);
                disableCheck = disabledMap.has(contactKey);
                if (multiple) {
                    checked = selectedMap.has(contactKey);
                }
            }
            else {
                const org = item;
                disableCheck = disabledMap.has(org.id);
                if ((_c = org.children) === null || _c === void 0 ? void 0 : _c.length) {
                    checked = !org.children.some(contactItem => !selectedMap.has(getContactItemKey(contactItem, useContactId)));
                    if (checked) {
                        console.warn('searchList checked', checked, org, selectedMap);
                    }
                }
                else {
                    checked = false;
                }
            }
            return (React.createElement("div", { className: styles.listItem, key: item.id + '::' + ((_d = item) === null || _d === void 0 ? void 0 : _d.email), style: Object.assign({}, style) },
                React.createElement(ListItem, { testId: "contact_selectList_search_list_item", onSelect: () => {
                        !disableCheck && handleSelectedItem(item, !checked);
                    }, onSelectMailListIcon: data => {
                        setShowMemberList(true);
                        setSelectedMailList(data);
                    }, type: "search", showAvatar: showAvatar, showCheckbox: showCheckbox, showPosition: showPosition, showMailListIcon: true, checked: checked, disableCheck: disableCheck, selected: selected, isLeaf: isLeaf, item: item, searchText: searchValue })));
        })))));
    const renderList = () => (searchList.length === 0 ? renderNoData() : renderData());
    const renderLoading = () => (React.createElement("div", { className: styles.listLoading },
        React.createElement(SpinIcon, { className: "sirius-spin" })));
    const content = searchListLoading ? renderLoading() : renderList();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.listContainer, "data-test-id": "contact_selectList_search_list" }, content),
        showMemberList && selectedMailList && (React.createElement(MemberList, { visible: showMemberList, user: selectedMailList.email, _account: _account, contactName: selectedMailList.name, onCancel: () => {
                setShowMemberList(false);
            } }))));
});
export default ContactList;
